import React from 'react';
import WaitingIndicatorTelly from '../general-components/waiting-indicator-telly';

interface MyProps {
	progress: number | undefined;
}

export default function UploadProgressIndicator(props: MyProps) {
	const {
		progress,
	} = props;

	return (
		<div className="attachment-waiting for-telly">
			{progress
				? (
					<div className="progress-wrap">
						<div
							className="progress-bar"
							style={{ width: `${progress}%` }}
							data-testid='progress-bar'
						>
						</div>
					</div>
				) : (
					<></>
				)
			}
			<WaitingIndicatorTelly />
		</div>
	);
}
